<template>
  <div class="audio-content" v-loading="loading">
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="mic_id" label="序号" width="100"> </el-table-column>
      <el-table-column prop="device_id" label="话筒设备ID" width="100"></el-table-column>
      <el-table-column prop="terminal_ip" label="话筒设备ip" width="100"></el-table-column>
      <el-table-column prop="terminal_number" label="设备终端ID"> </el-table-column>
      <el-table-column prop="ste" label="话筒状态"> </el-table-column>
      <el-table-column prop="link_status" label="链接状态"> </el-table-column>
      <el-table-column
        prop="edit"
        label="开启网络话筒"
        width="250"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            size="small"
            type="primary"
            @click="(dialogBox = true), openMic(scope.row.device_id)"
            round
            >开启</el-button
          >
          <el-button
            size="small"
            type="info"
            @click="closeMic(scope.row.device_id)"
            round
            >关闭</el-button
          >
        </template>
      </el-table-column>
	  <el-table-column prop="date" label="日期"> </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.page"
      :page-sizes="[10, 20, 30, 40, 50, 100]"
      :page-size="pageInfo.pageSize"
      layout="sizes, total, prev, pager, next, jumper"
      :total="cnt_all"
    >
    </el-pagination>

    <!--开启话筒-->
    <el-dialog
      custom-class="mw-edit-dialog"
      class="dialog600"
      title="开启话筒"
      :visible.sync="dialogBox"
      v-if="dialogBox"
    >
      <el-form
        :model="editBox"
        label-position="left"
        label-width="120px"
        :rules="editBoxRule"
      >
        <el-form-item label="设备终端编号" prop="terminal_number">
          <el-select
            placeholder="请选择设备终端编号"
            multiple
            v-model="editBox.terminal_number_arr"
          >
            <el-option
              v-for="t in devSelect"
              :key="t.terminal_number"
              :label="t.terminal_number"
              :value="t.terminal_number"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogBox = false">取消</el-button>
        <el-button type="primary" @click="setMic">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import micPhoneApi from "@/api/audio/micPhone";
import autoListApi from "@/api/audio/audioList";
export default {
  data() {
    return {
      loading: false,
      dialogBox: false,
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 20,
      },
      cnt_all: 0,
      editBoxRule: {
        terminal_number: [
          { required: true, message: "请选择设备", trigger: "blur" },
        ],
      },
      devSelect: [],
      editBox: {
        device_id: null,
        terminal_number: "",
        terminal_number_arr: [],
      },
    };
  },
  methods: {
    getTableData(pageIndex) {
      // 获取媒体列表
      this.pageInfo.page = pageIndex;
      this.loading = true;
      micPhoneApi.micPhoneList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
          this.getAudioList()
        }
      });
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },

    openMic(index) {
      //开启弹框
      this.editBox.device_id = index;
      this.dialogBox = true;
    },
    setMic() {
      let devId_arr = this.editBox.terminal_number_arr;
      if (devId_arr.length < 1) {
        this.$message.error("请选择设备");
        return;
      }
      let devId_str = "";
      if (devId_arr.length < 2) {
        devId_str = devId_arr[0];
      } else {
        devId_str = devId_arr.join("|");
      }
      this.editBox.terminal_number = devId_str;
      console.log('this.editBox',this.editBox)
      micPhoneApi.micPhoneOpen(this.editBox).then((res) => {
        if (res.data.code === 1000) {
          this.dialogBox = false;
          this.$message.success("网络话筒打开成功");
          this.editBox.device_id = null,
          this.editBox.terminal_number = '',
          this.editBox.terminal_number_arr = []
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    closeMic(device_id) {
      micPhoneApi
        .micPhoneClose({
          device_id: device_id,
        })
        .then((res) => {
          if (res.data.code === 1000) {
            this.$message.success("网络话筒关闭成功");
            this.getTableData(this.pageInfo.page);
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    getAudioList() {
      autoListApi.audioList({
          page: 1,
          pageSize: 200,
        }).then((res) => {
        if (res.data.code === 1000) {
          let resData = res.data.data;
          this.devSelect = resData.list;
        }
      });
    }
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
  },
};
</script>
<style lang='less' scoped>
.audio-content {
  width: 100%;
}
</style>